import {usePreviewContext} from '../context/PreviewContext';
import {LocalStorage} from '../utils/LocalStorage';

export const usePortalClientId = () => {
    const {isPreview, previewClientId} = usePreviewContext();
    if (isPreview && previewClientId) {
        return previewClientId;
    }
    return LocalStorage.fetchUserClientId();
};
